
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { Store, } from '~/apps/meter-read/store';
import ProgressSteps from '~/components/meter-read/meter-read-progress-steps.vue';
import Spinner from '~/components/spinner/spinner.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';

@Component({
	components: {
		Alert: () => import('~/components/alert/alert.vue'),
		Overlay: () => import('~/components/overlay/overlay.vue'),
		ProgressSteps,
		Spinner,
		UnauthedNav,
	},
	metaInfo: {
		title: 'Quick Submit meter read - Southern Water',
		meta: [
			{
				name: 'description',
				content: `Submit a meter reading online today. You can see how much water you've used and get an up to date bill.`,
			},
		],
	},
})
export default class MeterReadApp extends Vue {
	get currentStep() {
		return Store.state.currentStep;
	}

	get showSpinner() {
		return Store.state.showSpinner;
	}

	get showOverlay() {
		return Store.state.isOverlayVisible;
	}

	get overlayMessage() {
		return Store.state.overlayMessage;
	}

	get meterReading() {
		return Store.state.currentMeterReading;
	}

	get activeAlert() {
		return Store.state.alertModule.activeAlert;
	}

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	closeAlert() {
		Store.commit.dismissActiveAlert();
	}

	closeOverlay() {
		Store.commit.setMeterReading(0);
		Store.commit.closeOverlay();
	}

	overlaySubmit() {
		Store.commit.closeOverlay();
		void this.$router.push('./confirm-reading');
	}

	@Watch('$route')
	onRouteChange() {
		this.$nextTick(() => {
			const focusTarget = document.querySelector('header') as HTMLElement;
			focusTarget.setAttribute('tabindex', '-1');
			focusTarget.focus();
			focusTarget.removeAttribute('tabindex');
		});
	}
}
